module.exports = __webpack_public_path__ + "h5/img/1.1855873f.png";